export const PLINK_LINK = "https://plink.co.nz" as const;
export const PHOTOGRAPHY_LINK = "https://www.instagram.com/melissabanksphotographer/" as const;
export const WHAKAREWA_FACEBOOK = "https://www.facebook.com/ohumaatu" as const;
export const WHAKAREWA_VIMEO = "https://vimeo.com/user21172167" as const;
